module.exports = __webpack_public_path__ + "img/lion.9cf84576.svg";